import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Spinner, ListGroup } from 'react-bootstrap';
import ProgressBar from './ProgressBar';
import OptionsList from './OptionsList';
import { useCandidates, Candidate } from '../CandidatesContext';
import { useWeb3 } from '../Web3Context';


const BaseForm: React.FC = () => {
  const { connector, hooks } = useWeb3();
  
  const {useSelectedIsActive } = hooks
  const isActive = useSelectedIsActive(connector)

  const [stage, setStage] = useState(1);
  const [loading, setLoading] = useState<boolean>(false);
  const [loaded, setLoaded] = useState<boolean>(false);

  const { candidates, setCandidates } = useCandidates();
  const [candidatesValid, setCandidatesValid] = useState<boolean>(false);

  const totalStages = 3;

  const handleNext = () => {
    if (stage < totalStages) setStage(stage + 1);
  };

  const handlePrevious = () => {
    if (stage > 1) setStage(stage - 1);
  };

  useEffect(() => {
    if (stage === 2) {
      let valid = true;
      candidates.forEach(candidate => {
        if (candidate.selectedCandidate === null) {
          valid = false;
        }
      });
      setCandidatesValid(valid);
    }
  }, [stage, candidates]);

  useEffect(() => {

    if(isActive === true && stage === 1)
    {
      setLoading(true);
      let initialCandidates: Candidate[] = [];

      if( false ) {
        fetch('https://api.example.com/options') // Replace with your API endpoint
          .then(response => response.json())
          .then(data => {

            initialCandidates = data.ballot.positions.map((position: any) => ({
              title: position.title,
              selectedCandidate: null,
            }));

            setLoading(false);
            setLoaded(true);
          })
          .catch(error => {
            console.error('Error fetching options:', error);
          });
      }
      else {
        // Read ballot variable the positions.
        // For each one create an array state of candidates that will have the selected candidate and title.
        // This will be used to render the review and confirmation stages.
        initialCandidates = ballot.ballot.positions.map(position => ({
            title: position.title,
            selectedCandidate: null,
        }));
        setLoading(false);
        setLoaded(true);
      }
            
      setCandidates(initialCandidates);

      console.log('Candidates:', initialCandidates);
    }
    // eslint-disable-next-line
  }, [isActive]);

  // Example JSON data (replace with your actual JSON)
  const ballot = {
    ballot: {
      title: "Sample Ballot - Republican Party Primary",
      location: "Polk County, North Carolina",
      date: "March 5, 2024",
      instructions: [
        "With the marking device provided or a black ball point pen, completely fill in the oval to the left of each candidate or selection of your choice as shown.",
        "If you tear, deface or wrongly mark this ballot, return it to request a replacement.",
      ],
      "positions": [
        {
          "title": "Presidential Preference",
          "max_options": 1,
          "candidates": [
            "Ron DeSantis",
            "Nikki Haley",
            "Asa Hutchinson",
            "Vivek Ramaswamy",
            "Donald J. Trump",
            "Ryan Binkley",
            "Chris Christie",
            "No Preference"
            // "**User Input**"
          ]
        },
        {
          "title": "US House of Representatives District 14",
          "max_options": 1,
          "candidates": [
            "Jeff Gregory",
            "Lillian Joseph",
            "Tim Moore"
          ]
        },
        {
          "title": "NC Governor",
          "max_options": 1,
          "candidates": [
            "Dale R. Folwell",
            "Bill Graham",
            "Mark Robinson"
          ]
        },
        {
          "title": "NC Lieutenant Governor",
          "max_options": 1,
          "candidates": [
            "Rivera Douthit",
            "Jeffrey Elmore",
            "Marlenis Hernandez Novoa",
            "Allen Mashburn",
            "Jim O'Neill",
            "Sam Page",
            "Ernest T. Reeves",
            "Hal Weatherman",
            "Seth Woodall",
            "Deanna Ballard",
            "Peter Boykin"
          ]
        },
        {
          "title": "NC Auditor",
          "max_options": 1,
          "candidates": [
            "Charles Dingee",
            "Jim Kee",
            "Anthony Wayne (Tony) Street",
            "Jeff Tarte",
            "Dave Boliek",
            "Jack Clark"
          ]
        },
        {
          "title": "NC Treasurer",
          "max_options": 1,
          "candidates": [
            "A. J. Daoud",
            "Rachel Johnson",
            "Brad Briner"
          ]
        },
        {
          "title": "NC Court of Appeals Judge Seat 15",
          "max_options": 1,
          "candidates": [
            "Chris Freeman",
            "Hunter Murphy"
          ]
        },
        {
          "title": "NC Commissioner of Agriculture",
          "max_options": 1,
          "candidates": [
            "Colby (Bear) Hammonds",
            "Steve Troxler"
          ]
        },
        {
          "title": "NC Commissioner of Insurance",
          "max_options": 1,
          "candidates": [
            "Andrew Marcus",
            "C. Robert Brawley",
            "Mike Causey"
          ]
        },
        {
          "title": "NC Commissioner of Labor",
          "max_options": 1,
          "candidates": [
            "Luke Farley",
            "Jon Hardister",
            "Chuck Stanley",
            "Travis J. Wilson"
          ]
        },
        {
          "title": "NC Secretary of State",
          "max_options": 1,
          "candidates": [
            "Jesse Thomas",
            "Christine E. Villaverde",
            "Chad Brown"
          ]
        },
        {
          "title": "NC Superintendent of Public Instruction",
          "max_options": 1,
          "candidates": [
            "Michele Morrow",
            "Catherine Truitt"
          ]
        },
        {
          "title": "Polk County Board of Commissioners",
          "max_options": 3,
          "candidates": [
            "Jennifer Hargett",
            "Chris Jones",
            "Myron Yoder",
            "Paul (Little) Beiler"
          ]
        }
      ]
    }
  };

  return (
    <Container style={{ minHeight: '40vh', minWidth: '40vw', padding: '1rem' }}>
      {loaded && <ProgressBar style={{ width: '100%', backgroundColor: 'black', height:'1.5rem' }} currentStage={stage} totalStages={totalStages}/> }
          {stage === 1 && (
            <>
              {loaded === false && loading === false && <h1>Connect your wallet to load page</h1>}
              {loading && <Spinner animation="border" />}
              {loaded && <OptionsList list={ballot} />}
            </>
          )}
          {stage === 2 && (
            <>
              <h3>Review Your Options</h3>
              <p>Review the options below and make sure your selection is correct.</p>
              <p>Selected Options:</p>
              <ListGroup>
                {candidates.map((candidate) => (
                  <ListGroup.Item 
                    key={candidate.title}
                    variant={candidate.selectedCandidate === null ? "danger" : "success"}
                  >
                    {candidate.title}: <strong>{candidate.selectedCandidate === null ? "Not selected" : candidate.selectedCandidate }</strong>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </>
          )}
          {stage === 3 && (
            <>
              <Spinner animation="border" />
              {/* <h3>Transaction Confirmation</h3> */}
              {/* <p>Transaction Hash: [Your Transaction Hash]</p> */}
              <p>Status: Pending...</p>
            </>
          )}
          <Row className='d-flex justify-content-center justify-content-evenly'>
            {(stage === 2) && (
              <Col xs="auto">
                <Button onClick={handlePrevious}>Back</Button>
              </Col>
            )}
            {( (stage === 1 && true === loaded) ) && (
              <Col xs="auto">
                  <Button onClick={handleNext}>Next</Button>
              </Col>
            )}
            {( (stage === 2 && candidatesValid) ) && (
              <Col xs="auto">
                  <Button onClick={handleNext}>Submit</Button>
              </Col>
            )}
          </Row>
    </Container>
  );
};

export default BaseForm;